import { ReactionDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { Reaction } from '@/services/graphql/types';

export const mapperReaction = createEnumMapperFunction(
  ReactionDataEnum,
  Reaction
);
